import { useMemo } from 'react'

import { useManualTaskProcessorToolkit } from 'Automations/nodeDefinitions/hooks/useManualTaskProcessorToolkit'
import {
  CustomerInfoReviewInput,
  CustomerInfoReviewOutcome,
  CustomerInfoReviewViewModel
} from '../types'
import { mapInputToViewModel } from '../customerInfoDiff'

type UseCustomerInfoReviewTask = {
  viewModel: CustomerInfoReviewViewModel | undefined
  isPending: boolean
  handleClose: () => void
  completeTask: (outcome: CustomerInfoReviewOutcome) => Promise<boolean>
}

/**
 * Data seam for the customer-info review modal. Reads and completes the task
 * through the shared `useManualTaskProcessorToolkit` (real `getManualTask` /
 * `postCompleteManualTask`), and maps the raw task input into the view model the
 * components consume.
 */
export const useCustomerInfoReviewTask = ({
  taskId
}: {
  taskId: string
}): UseCustomerInfoReviewTask => {
  const { manualTask, isPending, handleClose, completeTask } =
    useManualTaskProcessorToolkit<CustomerInfoReviewInput>({ taskId })

  const viewModel = useMemo(
    () =>
      manualTask?.input ? mapInputToViewModel(manualTask.input) : undefined,
    [manualTask?.input]
  )

  return {
    viewModel,
    isPending,
    handleClose,
    completeTask
  }
}
